import styled from 'styled-components';

import { PartnerLink } from 'components/Links';

export const BackButton = styled(PartnerLink)`
  padding: 0;
`;
